import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingExclusion } from './types/Listing';
import { ListingExclusionsResponse } from './getListingExclusions';

interface ListingExclusionsPayload {
  dates: ListingExclusion[];
  adjustDates?: boolean;
  actionToken?: string;
}

const addListingExclusions = (makeCall: MakeCall) => (
  listingId: number,
  { dates, adjustDates = true, actionToken }: ListingExclusionsPayload,
) =>
  makeCall<ListingExclusionsResponse>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      data: {
        dates,
        adjustDates,
        actionToken,
      },
    },
  );

export default addListingExclusions;
